import React, { FunctionComponent, useCallback, useContext } from 'react';
import {
  PlaidLinkOnSuccess,
  PlaidLinkOnSuccessMetadata,
  usePlaidLink,
  PlaidLinkOptions,
  PlaidLinkOnEvent,
} from 'react-plaid-link';
import { useAuthToken } from '../../hooks';
import { onboardingapi } from '../../api';
import { AuthStore } from '../../context';
import { originUrl } from '../../util/api.util';
import { PlaidLinkOnExit } from 'react-plaid-link/src/types';
import { handlePlaidLinkError } from '../../util/plaid.util';

export const PlaidCallback: FunctionComponent = () => {
  const { authToken } = useAuthToken();
  const {
    state: { auth },
  } = useContext(AuthStore);
  const merchantId = auth?.merchant?.id;
  const linkToken = localStorage.getItem(`linkToken.${merchantId}`);
  // The usePlaidLink hook manages Plaid Link creation
  const onSuccess = useCallback<PlaidLinkOnSuccess>(
    async (public_token: string, metadata: PlaidLinkOnSuccessMetadata) => {
      // exchange public token and log and save metadata
      await onboardingapi.post(authToken!, '/banking/token/exchange', {
        public_token,
        metadata,
      });
      const financialRoute = originUrl('application/financial');
      window.location.href = financialRoute;
    },
    [authToken],
  );

  const onExit = useCallback<PlaidLinkOnExit>(() => {
    handlePlaidLinkError(authToken!);
  }, [authToken]);

  // It does not return a destroy function;
  // instead, on unmount it automatically destroys the Link instance
  const config: PlaidLinkOptions = {
    onSuccess,
    onExit,
    onEvent: onExit as unknown as PlaidLinkOnEvent,
    token: linkToken,
    receivedRedirectUri: `${window.location.origin}${window.location.search}`,
  };
  const { open, ready } = usePlaidLink(config);

  // open Link immediately when ready
  React.useEffect(() => {
    if (ready) {
      open();
    }
  }, [ready, open]);

  return <></>;
};
